import { CustomStyles } from './custom-styles';

export class SinclairCard {

    name: string;
    rows: number;
    title: string;
    subTitle: string;
    labelState: string;
    cardStyles: CustomStyles;
    customStyles: CustomStyles;
    filtersHeader: string;
    filtersOptionTooltip: string;
    stateClass: CustomStyles;
    tooltip: string;

    filters: SinclairCardFilterOption[];

    constructor(
        {
            name,
            rows = 1,
            title,
            subTitle= '',
            cardStyles = new CustomStyles(),
            customStyles = new CustomStyles(),
            filters = [],
            filtersHeader = '',
            filtersOptionTooltip = '',
            stateClass = new CustomStyles(),
            tooltip,
            labelState = ''
        }: SinclairCardParameters
    ) {
        this.name = name;
        this.rows = rows;
        this.title = title;
        this.subTitle = subTitle;
        this.cardStyles = cardStyles;
        this.customStyles = customStyles;
        this.filters = filters;
        this.filtersHeader = filtersHeader;
        this.filtersOptionTooltip = filtersOptionTooltip;
        this.labelState = labelState;
        this.stateClass = stateClass;
        this.tooltip = tooltip;
    }
}

export interface SinclairCardParameters {
    name:string;
    rows?: number;
    title: string;
    tooltip: string;
    subTitle?: string;
    cardStyles?: CustomStyles;
    customStyles?: CustomStyles;
    filters?: SinclairCardFilterOption[];
    filtersHeader?: string;
    filtersOptionTooltip?: string;
    stateClass?: CustomStyles;
    labelState?: string;
}

export class SinclairCardFilterOption {

    active: boolean;
    type: SinclairCardFilterOptionType;
    title: string;
    subTitle: string;
    tooltip: string;
    value: unknown;
    stateClass: CustomStyles;
    labelState: string;

    constructor({
        title,
        subTitle= '',
        type,
        tooltip,
        value,
        active = false,
        stateClass = new CustomStyles(),
        labelState = ''
    }: SinclairCardFilterOptionParameters
    ) {
        this.active = active;
        this.type = type;
        this.title = title;
        this.subTitle = subTitle;
        this.tooltip = tooltip;
        this.value = value;
        this.stateClass = stateClass;
        this.labelState = labelState;
    }
}

interface SinclairCardFilterOptionParameters {

    type: SinclairCardFilterOptionType;
    title: string;
    subTitle?: string;
    tooltip: string;
    value: unknown;

    active?: boolean;
    stateClass?: CustomStyles;
    labelState?: string;

}

export enum SinclairCardFilterOptionType {

    Label = 'label',
    DgeFilters = 'dge-filters'

}